
import { Component, Vue, Prop } from 'vue-property-decorator'
import backBtnGroup from './back-btn-group.vue'
@Component({
    components: {
        backBtnGroup
    }
})
export default class ErrorContent extends Vue {
    @Prop(String) readonly code!: string | undefined
    @Prop(String) readonly desc!: string | undefined
    @Prop(String) readonly src!: string | undefined

    name = 'error_content'
}
